import React from 'react';
import { Mail, Linkedin, Twitter, ArrowUpRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { contactData, siteConfig } from '../data/mock';

export const ContactSection = () => {
  return (
    <section id="contact" className="py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        {/* Section Title */}
        <h2 className="text-4xl sm:text-5xl font-extralight text-black mb-8 tracking-tight">
          {contactData.title}
        </h2>

        {/* Description */}
        <p className="text-lg text-gray-500 font-light mb-6">
          {contactData.description}
        </p>

        {/* Topics */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
          {contactData.topics.map((topic, index) => (
            <span
              key={index}
              className="text-gray-600 font-light"
            >
              {topic}{index < contactData.topics.length - 1 && <span className="text-gray-300 ml-3">•</span>}
            </span>
          ))}
        </div>

        <p className="text-lg text-gray-400 font-light mb-12">
          {contactData.outro}
        </p>

        {/* Contact Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Button
            asChild
            className="bg-rose-600 text-white hover:bg-rose-700 rounded-full px-8 py-6 text-sm font-normal group"
          >
            <a href={siteConfig.nexper} target="_blank" rel="noopener noreferrer">
              <Sparkles className="w-4 h-4 mr-2" />
              Book on NEXPER
              <ArrowUpRight className="w-4 h-4 ml-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
            </a>
          </Button>
          <Button
            asChild
            variant="outline"
            className="border-rose-200 text-rose-600 hover:bg-rose-50 hover:border-rose-300 rounded-full px-8 py-6 text-sm font-normal group"
          >
            <a href={`mailto:${siteConfig.email}`}>
              <Mail className="w-4 h-4 mr-2" />
              Email Me
              <ArrowUpRight className="w-4 h-4 ml-1 opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
            </a>
          </Button>
          <Button
            asChild
            variant="outline"
            className="border-rose-200 text-rose-600 hover:bg-rose-50 hover:border-rose-300 rounded-full px-8 py-6 text-sm font-normal group"
          >
            <a href={siteConfig.linkedin} target="_blank" rel="noopener noreferrer">
              <Linkedin className="w-4 h-4 mr-2" />
              LinkedIn
              <ArrowUpRight className="w-4 h-4 ml-1 opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
            </a>
          </Button>

        </div>
      </div>
    </section>
  );
};
